import React from 'react';
import { Link } from 'react-router-dom';

export interface Crumb {
  label: string;
  to?: string;
}

// "הכנסת › הליכוד › עמית הלוי". The last crumb is the current page and never a link.
const Breadcrumbs = ({ items }: { items: Crumb[] }) => (
  <nav aria-label="מיקום באתר" style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: '8px', fontSize: '13px', color: '#888' }}>
    {items.map((c, i) => {
      const isLast = i === items.length - 1;
      return (
        <React.Fragment key={`${i}_${c.label}`}>
          {i > 0 && <span aria-hidden="true" style={{ color: '#bbb' }}>›</span>}
          {c.to && !isLast
            ? <Link to={c.to} style={{ color: '#185FA5', textDecoration: 'none' }}>{c.label}</Link>
            : <span aria-current={isLast ? 'page' : undefined} style={{ color: '#555' }}>{c.label}</span>}
        </React.Fragment>
      );
    })}
  </nav>
);

export default Breadcrumbs;
